// category description
document.addEventListener('DOMContentLoaded', function() {
    const categoryDescContainer = document.querySelector('.category-desc.top');
    const topDesc = document.querySelector(".category-desc.top .top-desc") || document.querySelector(".category-desc.top .top-desc p");
    
    if (topDesc) {
        const fullText = topDesc.textContent.trim();
        const words = fullText.split(/\s+/); 
        const limit = 30;

        if (words.length > limit) {
            const shortText = words.slice(0, limit).join(' ') + '...';
            let expanded = false;

            const toggleBtn = document.createElement('a');
            toggleBtn.href = 'javascript:void(0);'; 
            toggleBtn.textContent = 'Read more';
            toggleBtn.className = 'toggle-btn';
            toggleBtn.style.marginLeft = '4px';

            topDesc.textContent = shortText;
            topDesc.appendChild(toggleBtn);

            toggleBtn.addEventListener('click', function (e) {
                e.preventDefault();
                expanded = !expanded;

                if (expanded) {
                    topDesc.textContent = fullText + ' ';
                    toggleBtn.textContent = 'Read less';
                } else {
                    topDesc.textContent = shortText;
                    toggleBtn.textContent = 'Read more';
                }
                
                topDesc.appendChild(toggleBtn);
            });
        }

        topDesc.classList.add('is-ready');
    }
});